import React, { Component } from 'react';
import AdminNavigationBar from './AdminNavigationBar';

class PasswordChange extends Component {

  constructor() {
    super();

    this.onOldPasswordUpdate = this.onOldPasswordUpdate.bind(this);
    this.onNewPasswordUpdate = this.onNewPasswordUpdate.bind(this);
    this.onRepeatedNewPasswordUpdate = this.onRepeatedNewPasswordUpdate.bind(this);
    this.changePassword = this.changePassword.bind(this);

    this.state = {
      oldPassword: '',
      newPassword: '',
      repeatedNewPassword: '',
      error: null,
      success: false
    };
  }

  render() {
    return (
      <div>
        <AdminNavigationBar />
        <div className="container">
          <h1>Zmiana hasła</h1>
          { this.state.success ? this.onSuccess() : this.form() }
        </div>
      </div>
    );
  }

  onSuccess() {
    return (<div className="inline-block alert alert-info">Hasło zostało zmienione.</div>);
  }

  form() {
    return (
          <form className="col-md-4">
              {this.state.error ? <div className="inline-block alert alert-danger">{this.state.error}</div> : ''}
              <div className="form-group">
                  <label for="oldPassword">Stare hasło</label>
                  <input
                    type="password"
                    className="form-control"
                    id="oldPassword"
                    value={this.state.oldPassword}
                    onChange={this.onOldPasswordUpdate()} />
              </div>
              <div className="form-group">
                  <label for="newPassword">Nowe hasło</label>
                  <input
                    type="password"
                    className="form-control"
                    id="newPassword"
                    value={this.state.newPassword}
                    onChange={this.onNewPasswordUpdate()} />
              </div>
              <div className="form-group">
                  <label for="repeatedNewPassword">Powtórz nowe hasło</label>
                  <input
                    type="password"
                    className="form-control"
                    id="repeatedNewPassword"
                    value={this.state.repeatedNewPassword}
                    onChange={this.onRepeatedNewPasswordUpdate()} />
              </div>
              <button type="submit" className="btn btn-primary" onClick={this.changePassword}>Zmień</button>
          </form>
    );
  }

  onOldPasswordUpdate() {
    return (evt) => {
      this.setState({oldPassword: evt.target.value});
    };
  }

  onNewPasswordUpdate() {
    return (evt) => {
      this.setState({newPassword: evt.target.value});
    };
  }

  onRepeatedNewPasswordUpdate() {
    return (evt) => {
      this.setState({repeatedNewPassword: evt.target.value});
    };
  }

  changePassword() {
    if (this.state.newPassword !== this.state.repeatedNewPassword) {
      this.setState({error: 'Nowe hasło i powtórzone nowe hasło nie są zgodne.'});
      return;
    }

    fetch(
        `/api/password`,
        {
          method: 'PUT',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            oldPassword: this.state.oldPassword,
            newPassword: this.state.newPassword
          })
        }
      ).then(response => {
        if (response.status === 200) {
          this.setState({success: true});
        } else {
          response.json().then(data => this.setState({
            error: 'Podano nieprawidłowe stare hasło.'
          }));
        }
      });
  }
}

export default PasswordChange;



// WEBPACK FOOTER //
// ./components/PasswordChange.js